import type { UseListProps, UseListResult } from '../useList'
import { useList } from '../useList'
import { templateQueries } from './graphql'
import type { Template } from '@ztechapps/common.contract'

/**
 * Get all templates from the database
 */
export const useTemplateList = (props: Partial<UseListProps>): UseListResult<Template> => {
  return useList<Template>({
    ...templateQueries.allConfig,
    limit: 0,
    ...props,
  })
}
